import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { CustomTabs } from "../../../components";
import { Received, Withdraw } from "./components";
const TradeRecord = () => {
  const [params] = useSearchParams();
  const { t } = useTranslation();
  const tabItems = [
    {
      key: "withdraw",
      title: t("tradeRecord.tab.withdraw"),
      component: <Withdraw />,
      destroyOnClose: true,
    },
    {
      key: "received",
      title: t("tradeRecord.tab.received"),
      component: <Received />,
      destroyOnClose: true,
    },
  ];
  const [activeTab, setActiveTab] = useState(params.get("tab") ? params.get("tab") : "received");

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div>
      <CustomTabs activeKey={activeTab} onTabChange={onTabChange} tabItems={tabItems} />
    </div>
  );
};

export default TradeRecord;
